import { SVGProps } from 'react';

export function CatNeutralFace(props: SVGProps<SVGSVGElement>) {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" data-testid="cat-neutral-face" {...props}>
      <g id="color">
        <path
          fill="#F4AA41"
          stroke="none"
          d="M58.4953,11.21c0,0-10.4076,2.3754-15.5743,6.7088c0,0-9-2.5-13.8333,0.1667 c0,0-9.6549-6.7318-15.6549-6.7318c0,0-5.0326,3.75,0.3216,21.0651c0,0-2.6667,10.6667,1.6667,16.3333s9.8333,9.5,9.8333,9.5 l8.7917,4.0417l3.9583,0.1667l9.9167-4.375c0,0,6.6667-4.8333,8.8333-9.5c2.1667-4.6667,2.1667-13.8333,2.1667-13.8333l-1-3.3333 l2.8333-11.0208L58.4953,11.21z"
        />
        <path
          fill="#FFFFFF"
          stroke="none"
          d="M30.8377,47.3355c0,0-7.625,2.75-1.375,9.25c0,0-0.9739,4.625,3.8034,5.4849h5.1966 c2.0529,0.0031,4.5833-1.0683,3.7404-5.3628c0,0,7.5513-6.3722-1.3654-9.3722l-4.875,2L30.8377,47.3355z"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <ellipse cx="45.0854" cy="38.1033" rx="1.6461" ry="2.8119" fill="#000000" stroke="none" />
        <ellipse cx="26.8427" cy="38.1033" rx="1.6461" ry="2.8119" fill="#000000" stroke="none" />
        <polyline
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          points="31.9328,47.2287 36.037,50.0204 39.8495,47.2287"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M36.037,50.0204v4.2708c0,0-1.1042,3.6875-5.5417,2.875"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M15.8717,48.4759c-4.8928-7.2535-2.0014-15.8722-2.0014-15.8722s-5.25-14.875-0.4375-21.25c0,0,9.1875,1.5,15.6875,7.375 c4.5946-1.9379,9.1575-2.0128,13.6875-0.1437c6.5-5.875,15.6875-7.375,15.6875-7.375c4.8125,6.375-0.4375,21.25-0.4375,21.25 s2.8914,8.6187-2.0014,15.8722"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M14.7453,15.1037c0,0,12.8125,6.1875,10.0625,11.8125"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M24.8491,50.8753c0,0-9.3615-0.458-13.6525,7.5243"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M35.8911,49.8767v4.2708c0,0,1.1042,3.6875,5.5417,2.875"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M57.1828,14.96c0,0-12.8125,6.1875-10.0625,11.8125"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M47.2048,54.6836c0,0,8.2116,2.2454,8.6795,11.2958"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M48.079,50.7316c0,0,9.3615-0.458,13.6525,7.5243"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M31.3859,60.7598c3.88,1.6845,5.6481,1.8093,9.3021,0"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M25.4446,54.6836c0,0-8.2116,2.2454-8.6795,11.2958"
        />
      </g>
    </svg>
  );
}
